export const PieChartColors = [
        '#3F6BB4',
        '#6688BF',
        '#9CB5DF',
        '#CAD9F4'
    ];